import { type ReactNode } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { PublicChatWidget } from '../components/PublicChatWidget'
import { WhatsAppButton } from '../components/shared/WhatsAppButton'
import type { Customer, HotelProfile } from '../api/types'

export function Layout({
  hotel,
  customer,
  onLogout,
  children,
}: {
  hotel?: HotelProfile
  customer: Customer | null
  onLogout: () => void
  children: ReactNode
}) {
  return (
    <div className="flex min-h-screen flex-col bg-cream-light">
      <Header hotel={hotel} customer={customer} onLogout={onLogout} />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppButton />
      <PublicChatWidget customer={customer} />
    </div>
  )
}
